import { Incidencias } from "./incidencia.model";

export class IncidenciaDTO {
    listaIncAbierto: Incidencias[] = [];
	listaIncObservacion: Incidencias[] = [];
	listaIncProceso: Incidencias[] = [];
	listaIncResuelto: Incidencias[] = [];
	listaIncRevision: Incidencias[] = [];
	listaIncVOBO: Incidencias[] = [];
    listaIncCancelado: Incidencias[] = [];

	totalItemsObservacion : number;
    totalItemsAbierto: number;
    totalItemsProceso: number;
	totalItemsResuelto: number;
	totalItemsRevision: number;
	totalItemsVOBO: number;
	totalItemsCancelado: number;

}
    